import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { Shape2, Shape2Icon } from '../../Shape2/Shape2';

import './DraggableHelpHead.css';

interface DraggableHelpHeadProps {
    title: string;
    handleClassName: string;
    onClose: () => void;
}

export class DraggableHelpHead extends React.PureComponent<
    DraggableHelpHeadProps
> {
    render() {
        const { handleClassName, title } = this.props;
        return (
            <div
                className={classNames(
                    handleClassName,
                    Bem.cls('draggable-help-head')
                )}
            >
                <h3 className={Bem.cls('draggable-help-head', 'title')}>
                    {title}
                </h3>
                <div
                    className={Bem.cls('draggable-help-head', 'close')}
                    onClick={this.onClose}
                >
                    <Shape2 width={16} height={16} icon={Shape2Icon.close} />
                </div>
            </div>
        );
    }

    private onClose = () => {
        this.props.onClose();
    };
}
